import m from './module';

import OpportunityInvitation from '../model/OpportunityInvitation';
import { createError } from '../util';

const type = 'OpportunityInvitation';
const getOpportunityInvitationsForStaffingUserPath = '/staffing_user/{{staffing_users_id}}/opportunity_invitations';


class OpportunityInvitationService {
  constructor(
    $q,
    DataSyncService,
    LogService
  ) {
    this.$q = $q;
    this.DataSyncService = DataSyncService;
    this.LogService = LogService;
  }

  create(data) {
    const opportunityInvitation = new OpportunityInvitation(data);
    return this.$q.when(opportunityInvitation);
  }

  getAllForStaffingUser(staffingUser, config = null) {
    const path = getOpportunityInvitationsForStaffingUserPath.replace('{{staffing_users_id}}', staffingUser.id);
    const factory = data => this.create(data);
    return this.DataSyncService.getMultipleObjects(type, path, factory, config)
      .catch(response => {
        this.LogService.error(`OpportunityInvitationService.getAllForStaffUser(id=${staffingUser.id}). response:`, response);
        return this.$q.reject(createError({
          error: 'ErrorRetrievingOpportunityInvitations',
          message: 'Error retrieving opportunity invitations',
          response,
        }));
      })
  }

  groupOpportunityInvitationsByResponse(opportunityInvitations) {
    const grouped = opportunityInvitations.reduce((acc, curr) => {
      if (curr.isInterested) {
        acc.interested.push(curr);
      } else if (curr.isNotInterested) {
        acc.notInterested.push(curr);
      } else {
        acc.pending.push(curr);
      }
      return acc;
    }, {
      pending: [],
      interested: [],
      notInterested: [],
    });
    return grouped;
  }
}

export default OpportunityInvitationService;
m.service('OpportunityInvitationService', OpportunityInvitationService);
